<template>
  <div class="main-container">
    <div class="table-box">
      <loading :isShow="listLoading" />
      <div class="tools-box">
        <Button @click="goback" type="primary" ghost>返回</Button>
      </div>
      <template v-if="detail.delList.length">
        <p class="title">减保记录</p>
        <Table :columns="columns" :data="detail.delList">
        </Table>
        <Divider />
      </template>
      <p class="title">待开票记录</p>
      <p class="title"><span>
          1. 已完成付款并生效的保单或批单，可以进行在线申请发票的操作。 2. 保单项下全部未申请开票的批单必须一次性提交开票。 3. 当待开票金额大于0时，方可提交开票申请。 4.
          发票状态为“已申请”表示已完成发票开票申请，可以联系相关服务人员确认发票寄送进度。 5. 实际开票金额，如有细微偏差，请以保司为准
        </span></p>
      <Table :columns="waitColumns" :data="detail.waitInvoiceRecordVos">
      </Table>
      <Divider />
      <div class="total-box">
        <span>开票金额 <b>{{ detail.amount | number_format(2) }}</b> 元</span>
        <Button @click="getInvoice" type="primary">提交开票申请</Button>

      </div>
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { number_format } from '@/api/filter';
export default {
  mixins: [pageTool, common],
  components: {
  },
  data() {
    return {
      loading: false,
      detail: {},
      columns: [
        {
          title: "创建日期",
          key: 'createTime',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '批单号',
          key: 'bussninessNo',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '批改内容',
          minWidth: 160,
          align: 'center',
          key: 'bussinessInfo',
        },
        {
          title: '批改保费',
          key: 'fee',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.fee, 2)}</span>;
          }
        }
      ],
      waitColumns: [
        {
          title: "创建日期",
          key: 'createTime',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '业务类型',
          key: 'bussiness',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '单号',
          key: 'bussninessNo',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '业务内容',
          key: 'bussinessInfo',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '保费',
          key: 'fee',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.fee, 2)}</span>;
          }
        }
      ]

    };
  },
  created() {
    this.getList();
  },
  methods: {
    goback() {
      // this.back({ path: '/orderManage/group/policyDetail', query: this.$route.query });
      this.back({ path: '/orderManage/group/policyDetail', query: this.$route.query });
    },
    getInvoice() {
      this.listLoading = true;
      this.$http({
        url: `/buz/grouppolicy/invoice`,
        type: "GET",
        data: {
          policyNo: this.$route.query.policyNo
        }
      }).then((res) => {
        this.listLoading = false;
        if (res.data.httpCode == 200) {
          this.$notice.success('申请成功');
          this.goback()
        }
      }).catch(() => {
        this.listLoading = false;
      })
    },
    getList() {
      this.$http({
        url: `/buz/invoiceRecord/waitApplyList`,
        type: "GET",
        data: {
          policyNo: this.$route.query.policyNo
        }
      }).then((res) => {
        this.detail = res.data;
      })
    },
    policyDetail() { },
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin-top: 10px;
  margin-bottom: 10px;
}

.tools-box {
  display: flex;
  justify-content: flex-end;
}

.total-box {
  font-size: 16px;

  span {
    margin-right: 10px;

    b {
      font-weight: 400;
      margin-left: 4px;
    }
  }
}
</style>
